import {
  type AiGeneratedBookCover,
  type Caption,
  type Cover,
  type DesignedCover,
  PageSide,
  type PhotoCover,
  type StagedCover,
} from './PhotoBook.types'

// Which side of a sheet faces the reader: everything before the open spread has
// been flipped over, so its back is showing.
export function getPageSide(
  pageIndex: number,
  currentPageIndex: number
): PageSide {
  return pageIndex < currentPageIndex ? PageSide.BACK : PageSide.FRONT
}

export function isPhotoCover(
  cover: Cover | null | undefined
): cover is PhotoCover {
  return cover?.type === 'photo'
}

export function isDesignedCover(
  cover: Cover | null | undefined
): cover is DesignedCover {
  return cover?.type === 'designed'
}

export function isAiGeneratedCover(
  cover: Cover | null | undefined
): cover is AiGeneratedBookCover {
  return cover?.type === 'ai-generated'
}

export function isStagedCoverTheCurrentCover(
  cover: Cover | null,
  stagedCover: StagedCover
) {
  return stagedCover.type === 'photo'
    ? isPhotoCover(cover) && cover.photo.uid === stagedCover.photo.uid
    : isAiGeneratedCover(cover) &&
        cover.coverUrl === stagedCover.aiCover.coverUrl
}

export function getBookCaption(cover: Cover): Caption {
  return isAiGeneratedCover(cover) ? cover.bookCaption : cover.caption
}
